import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngChartsComponent } from './kng-charts.component';
import { KngChartsService } from './kng-charts.service';
import { NgChartsModule } from 'ng2-charts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { KngLoaderModule } from '../loader';

@NgModule({
	declarations: [KngChartsComponent],
	imports: [ CommonModule, NgChartsModule, MatTooltipModule, KngLoaderModule ],
	exports: [KngChartsComponent],
	providers: [KngChartsService]
})
export class KngChartsModule {}
